import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFunnelHasNearby = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6111 1.375H1.38841C0.650126 1.375 0.23997 2.25 0.704813 2.82422L5.76341 8.89453V11.4375C5.76341 11.6562 5.84544 11.875 6.03684 11.9844L8.22434 13.5156C8.33372 13.5977 8.47044 13.625 8.57981 13.625C8.93528 13.625 9.26341 13.3789 9.26341 12.9688V8.89453L14.2947 2.82422C14.7595 2.25 14.3493 1.375 13.6111 1.375ZM8.57981 8.34766L8.38841 8.59375V12.5586L6.63841 11.3281V8.59375L6.41966 8.34766L1.38841 2.25H13.6111L8.57981 8.34766Z",
			fill: "#607D8B"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12.5,
			cy: 2.5,
			r: 2.5,
			fill: "#4A209C"
		})
	]
});
const ForwardRef = forwardRef(SvgFunnelHasNearby);
export { ForwardRef as ReactComponent };
